import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { TitleService } from '../../../services/title.service';
@Component({
  selector: 'app-faq-page',
  imports: [MatExpansionModule],
  templateUrl: './faq-page.html',
  styleUrl: './faq-page.scss',
})
export class FaqPage {
  faqs = [
    {
      category: 'Orders & Payments',
      questions: [
        {
          q: 'What payment methods do you accept?',
          a: '<p>We accept secure payments via <strong>Stripe</strong>, including major credit and debit cards.</p>',
        },
        {
          q: 'Will I be charged right away after placing an order?',
          a: '<p>Yes, your payment method will be charged at checkout once your order is confirmed.</p>',
        },
        {
          q: 'Are prices listed in USD?',
          a: '<p>Yes, all prices are shown in <strong>USD</strong>.</p>',
        },
      ],
    },
    {
      category: 'Shipping',
      questions: [
        {
          q: 'Where do you ship from?',
          a: '<p>All orders are shipped directly from <strong>China to the United States</strong>.</p>',
        },
        {
          q: 'How much is shipping?',
          a: '<p>Shipping costs and estimated delivery times are shown at checkout.</p>',
        },
        {
          q: 'Do you cover customs delays?',
          a: '<p>No, we are not responsible for carrier or customs-related delays.</p>',
        },
      ],
    },
    {
      category: 'Returns & Exchanges',
      questions: [
        {
          q: 'What is your return policy?',
          a: '<p>You can request a return within <strong>30 days</strong> of delivery. Items must be unused, unwashed, and have all original tags attached.</p>',
        },
        {
          q: 'How do I start a return or exchange?',
          a: "<p>Email us at <a href='mailto:support@pinksoul.us'>support@pinksoul.us</a> with your order number, the item(s) you wish to return or exchange, and the reason.</p>",
        },
        {
          q: 'Do I need to pay for return shipping?',
          a: '<p>Yes, customers are responsible for return shipping costs, unless the item is defective or incorrect.</p>',
        },
        {
          q: 'How long does it take to get a refund?',
          a: '<p>Refunds are processed within <strong>5–10 business days</strong> after we receive your return. Shipping fees are non-refundable.</p>',
        },
        {
          q: 'Can I exchange an item?',
          a: '<p>Yes, exchanges are available based on product availability.</p>',
        },
        {
          q: 'What items are not eligible for return?',
          a: '<p>Final sale items, accessories, and gift cards are <strong>non-returnable</strong>.</p>',
        },
      ],
    },
    {
      category: 'Damaged or Wrong Items',
      questions: [
        {
          q: 'What if I received a damaged or incorrect item?',
          a: "<p>Please contact us within <strong>7 days</strong> of delivery at <a href='mailto:support@pinksoul.us'>support@pinksoul.us</a> with a photo and description. We’ll resolve it quickly.</p>",
        },
      ],
    },
    {
      category: 'Account & Privacy',
      questions: [
        {
          q: 'Do I need an account to shop?',
          a: '<p>No, you can check out as a guest. However, creating an account allows you to track orders and save details for faster checkout.</p>',
        },
        {
          q: 'How is my personal information used?',
          a: '<p>We use your information only to process orders, provide customer support, and send updates (you can unsubscribe anytime).</p>',
        },
        {
          q: 'Do you sell my information to third parties?',
          a: '<p>No. We do not sell or rent your personal data.</p>',
        },
        {
          q: 'How do I update or delete my account?',
          a: "<p>You can log in to your account or email us at <a href='mailto:support@pinksoul.us'>support@pinksoul.us</a> to update or delete your information.</p>",
        },
      ],
    },
    {
      category: 'Website & Cookies',
      questions: [
        {
          q: 'Do you use cookies?',
          a: '<p>Yes, cookies help us improve your shopping experience. You may disable them in your browser, but some features may not work properly.</p>',
        },
      ],
    },
    {
      category: 'Contact',
      questions: [
        {
          q: 'How can I contact customer support?',
          a: "<p>For all questions, email us at:</p><ul><li><a href='mailto:support@pinksoul.us'>support@pinksoul.us</a> (returns & exchanges)</li><li><a href='mailto:support@pinksoul.us'>support@pinksoul.us</a> (general inquiries & account support)</li></ul>",
        },
      ],
    },
  ];
  constructor(private titleService: TitleService) {
    this.titleService.setTitle('Frequently Asked Questions');
  }
}
